import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompletedMaintenancesTableComponent } from '../completed-maintenances-table/completed-maintenances-table.component';
import { PreventiveVsReactiveComponent } from '../../../maintenance-dashboard/components/graphs/preventive-vs-reactive/preventive-vs-reactive.component';
import { ReactiveMaintenanceGraphComponent } from '../graphs/reactive-maintenance-graph/reactive-maintenance-graph.component';
import { CompletedMaintenanceDetailsResponse } from '../../models/maintenance-overview-response.model';

@Component({
  selector: 'app-completed-maintenance-overview',
  standalone: true,
  imports: [
    CommonModule,
    CompletedMaintenancesTableComponent,
    PreventiveVsReactiveComponent,
    ReactiveMaintenanceGraphComponent
  ],
  templateUrl: './completed-maintenance-overview.component.html',
  styleUrl: './completed-maintenance-overview.component.scss'
})
export class CompletedMaintenanceOverviewComponent {
  // Table inputs
  @Input() completedMaintenances: CompletedMaintenanceDetailsResponse[] = [];
  @Input() isLoading: boolean = false;
  @Input() hasError: boolean = false;
  @Input() searchTerm: string = '';
  @Input() currentPage: number = 1;
  @Input() pageSize: number = 10;
  @Input() totalCount: number = 0;
  @Input() totalPages: number = 1;

  // Table outputs
  @Output() searchTermUpdated = new EventEmitter<string>();
  @Output() exportClicked = new EventEmitter<void>();
  @Output() pageChanged = new EventEmitter<number>();

  onSearchTermUpdate(searchTerm: string): void {
    this.searchTermUpdated.emit(searchTerm);
  }

  onExportClick(): void {
    this.exportClicked.emit();
  }

  onPageChange(page: number): void {
    this.pageChanged.emit(page);
  }
}